(function () {
	angular
		.module('trackeye')
		.factory('SubscriptionService', SubscriptionService);

	SubscriptionService.$inject = [];

	function SubscriptionService() {
		var exports = {};

		return exports;
	}
})();